import { Dialog, Toast } from 'vant';

const DEFAULT_CA_MESSAGE = '司机未完成CA认证，请先认证';
const DRIVER_CA_CONFIRM_MESSAGE = '依照工信部发布的《电子认证业务规则规范》，在线签章需要完成实名认证！';
const DRIVER_CA_RETURN_SKIP_KEY = 'driver_ca_return_skip_once';

const isObject = value => Object.prototype.toString.call(value) === '[object Object]';
const getCurrentPageUrl = () => `${window.location.origin}${window.location.pathname}${window.location.search}`;

const safeSessionStorage = {
  getItem(key) {
    try {
      return window.sessionStorage.getItem(key);
    } catch (error) {
      return null;
    }
  },
  setItem(key, value) {
    try {
      window.sessionStorage.setItem(key, value);
    } catch (error) {
      //
    }
  },
  removeItem(key) {
    try {
      window.sessionStorage.removeItem(key);
    } catch (error) {
      //
    }
  }
};

export const resolveDriverCaAuthResult = data => {
  if (!data) return null;
  if (typeof data === 'string') {
    return {
      passed: false,
      authUrl: data,
      message: DEFAULT_CA_MESSAGE
    };
  }
  if (!isObject(data)) return null;
  if (!('passed' in data) && !('authResult' in data) && !('authUrl' in data)) return null;
  return {
    passed: data.passed === true || data.authResult === 1,
    authUrl: data.authUrl || '',
    message: data.message || DEFAULT_CA_MESSAGE
  };
};

export const handleDriverCaAuthRedirect = data => {
  const result = resolveDriverCaAuthResult(data);
  if (!result || result.passed) return false;
  if (result.authUrl) {
    safeSessionStorage.setItem(DRIVER_CA_RETURN_SKIP_KEY, getCurrentPageUrl());
    window.location.href = result.authUrl;
    return true;
  }
  Toast.fail(result.message || DEFAULT_CA_MESSAGE);
  return true;
};

export const confirmDriverCaAuthRedirect = async data => {
  const result = resolveDriverCaAuthResult(data);
  if (!result || result.passed) return false;
  if (result.authUrl) {
    try {
      await Dialog.confirm({
        message: DRIVER_CA_CONFIRM_MESSAGE,
        confirmButtonText: '去认证',
        cancelButtonText: '取消',
        closeOnClickOverlay: true
      });
    } catch (error) {
      return true;
    }
    safeSessionStorage.setItem(DRIVER_CA_RETURN_SKIP_KEY, getCurrentPageUrl());
    window.location.href = result.authUrl;
    return true;
  }
  Toast.fail(result.message || DEFAULT_CA_MESSAGE);
  return true;
};

export const shouldSkipDriverCaAutoCheck = () => {
  const cachedUrl = safeSessionStorage.getItem(DRIVER_CA_RETURN_SKIP_KEY);
  const currentUrl = getCurrentPageUrl();
  if (cachedUrl && cachedUrl === currentUrl) {
    safeSessionStorage.removeItem(DRIVER_CA_RETURN_SKIP_KEY);
    return true;
  }
  return false;
};
